export const PUSH_PREVIOUS_REGULAR_ROUTE =
  'Location/PUSH_PREVIOUS_REGULAR_ROUTE';
